module.exports = __webpack_public_path__ + "img/icon-log-out.bc4b927d.png";